import React from 'react'

import {noop} from 'es-toolkit'

import './context-menu.scss'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    children: React.ReactNode
    onClose?: () => void
    size?: '90' | '100'
    maxHeight?: boolean
  }
>

export const ContextMenuContext = React.createContext({onClose: noop, size: '100'})

const ContextMenu = ({
  className,
  children,
  onClose = noop,
  size = '100',
  maxHeight = false,
  ...props
}: Props) => {
  const contextValue = React.useMemo(() => ({onClose: onClose || noop, size}), [onClose, size])
  return (
    <div {...props} className={cn('ContextMenu', {[`size-${size}`]: !!size, maxHeight}, className)}>
      <ContextMenuContext.Provider value={contextValue}>{children}</ContextMenuContext.Provider>
    </div>
  )
}

export default ContextMenu
